import { render } from "./CRMDatatableTDTaskStatus.vue?vue&type=template&id=031983e5&scoped=true"
import script from "./CRMDatatableTDTaskStatus.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTDTaskStatus.vue?vue&type=script&lang=js"

import "./CRMDatatableTDTaskStatus.vue?vue&type=style&index=0&id=031983e5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031983e5"]])

export default __exports__